import { render, staticRenderFns } from "./ConfirmationMenu.vue?vue&type=template&id=458f18fc"
import script from "./ConfirmationMenu.vue?vue&type=script&lang=js"
export * from "./ConfirmationMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports